module.exports = __webpack_public_path__ + "static/media/IZScreen Shot 2022-05-25 at 10.43.06 AM.0a3c3848.png";